/** The app's name, first in every page title (`usePageTitle`). `web/index.html` carries the same text. */
export const APP_NAME = "AI Lab";
